






























import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'BinsNumber',
  props: {
    value: {
      type: Array as PropType<string[]>,
      required: true,
    },
    update: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    bin: '',
    bins: [] as string[],
  }),
  watch: {
    update: {
      handler(value: boolean) {
        if (value) {
          this.bins = this.value;
        } else {
          this.bins = [];
          this.$emit('input', []);
        }
      },
    },
  },
  methods: {
    addBins(e: KeyboardEvent) {
      e.preventDefault();
      if (!this.bin) {
        return;
      }
      this.bins.push(this.bin);
      this.bin = '';
      this.$emit('input', this.bins);
    },
    removeBin(bin: string) {
      this.bins = this.bins.filter((b) => b !== bin);
      this.$emit('input', this.bins);
    },
  },
});
